$(document).ready(function() {
  function isElementInViewport(el) {
    const rect = el.get(0).getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
    );
  }

  function checkVideosInView() {
    $('.video-autoplay').each(function() {
      const section = $(this);
      const video = section.find('video').get(0);

      if (isElementInViewport(section) && video.paused) {
        video.play();
      }
    });
  }

  // Run on scroll and on load
  $(window).on('scroll load', function() {
    checkVideosInView();
  });
});

$(document).ready(function() {$('section .accordion').click(function() {$(this).siblings('.accordion[aria-expanded="true"]').attr('aria-expanded', 'false');});});


// Run after jQuery is loaded
jQuery(document).ready(function($) {
  // Check if URL contains /blogs/magazine/
  if (window.location.pathname.indexOf('/blogs/magazine/') === 0) {
    // Select all links inside .articleMain
    $('.articleMain a').each(function() {
      $(this).attr('target', '_blank').attr('rel', 'noopener noreferrer');
    });
  }
});



/* calculator */
(function(){

  // ── Constants ──────────────────────────────────────────────
  var M  = 75;    // minutes to manually review one document
  var A  = 5;     // minutes for AI to process one document
  var FY = 1720;  // working hours in a full year (1 FTE)

  // Tracing depth options — s = avg supplier documents per PO
  var D = [{s:4},{s:8},{s:15},{s:25}];
  // [0] Tier 1, [1] Tier 1–2, [2] Tier 1–3, [3] Full supply chain

  // Market multipliers — complexity/volume factor per region
  var K = [{m:1.0},{m:1.1},{m:1.2},{m:1.3}];
  // [0] EU, [1] US, [2] EU+US, [3] Global

  // ── State ──────────────────────────────────────────────────
  var pos = 3000; // purchase orders per year
  var di  = 2;    // selected depth index
  var mi  = 1;    // selected market index

  // ── Formatters ─────────────────────────────────────────────
  function fH(h){ // format hours → "15,500 hrs"
    return Math.round(h).toLocaleString() + ' hrs';
  }

  function fF(f){ // format FTE → "1.23 FTE"
    return f.toFixed(2) + ' FTE';
  }

  function fD(d){ // format document count → "15,500"
    return Math.round(d).toLocaleString();
  }

  // ── Core calculation ───────────────────────────────────────
  function calc(){
    var s = D[di].s;          // docs per PO for selected depth
    var m = K[mi].m;          // market multiplier
    var depthMult = s/D[0].s; // normalise depth against Tier 1 baseline (s=4)

    var td = pos * s * 4.5 * m;          // total documents processed by AI
    var mH = pos * M / 60 * m * depthMult; // manual hours/year
    var aH = pos * A / 60 * m * depthMult; // AI hours/year
    var sv = mH - aH;                    // hours saved/year

    return {
      td:  td,          // documents/year
      mH:  mH,          // manual hours
      aH:  aH,          // AI hours
      sv:  sv,          // hours saved
      mF:  mH / FY,     // manual FTE
      sF:  sv / FY,     // FTE freed up
      aF:  aH / FY,     // AI FTE equivalent
      pct: Math.round(sv / mH * 100)  // % time reduction
    };
  }

  // ── Slider fill ────────────────────────────────────────────
  function upSlider(){
    var sl = document.getElementById('tsc-slider');
    var p  = ((pos - 50) / (20000 - 50)) * 100; // % fill based on pos
    sl.style.background =
      'linear-gradient(to right,#37B4B4 0%,#37B4B4 '+p+'%,#E9E6D9 '+p+'%,#E9E6D9 100%)';
  }

  // ── Render all outputs ─────────────────────────────────────
  function render(){
    var r = calc();

    // PO count + slider
    document.getElementById('tsc-po-display').textContent = pos.toLocaleString();
    document.getElementById('tsc-slider').value = pos;
    upSlider();

    // Compare cards
    document.getElementById('tsc-manual-hrs').textContent = fH(r.mH);
    document.getElementById('tsc-manual-fte').textContent = fF(r.mF)+' equivalent';
    document.getElementById('tsc-ai-hrs').textContent     = fH(r.aH);
    document.getElementById('tsc-ai-fte').textContent     = fF(r.aF)+' equivalent';

    // Impact metrics
    document.getElementById('tsc-saved-hrs').textContent  = fH(r.sv);
    document.getElementById('tsc-pct').textContent        = r.pct+'% reduction';
    document.getElementById('tsc-saved-fte').textContent  = fF(r.sF);
    document.getElementById('tsc-docs').textContent       = fD(r.td);

    // Teaser — only shown when not already on Full supply chain
    var t = document.getElementById('tsc-teaser');
    if(di < 3){
      var fs = pos * (M - A) / 60 * K[mi].m; // max possible savings at full depth
      t.style.display = 'flex';
      document.getElementById('tsc-teaser-text').innerHTML =
        '<strong>Full supply chain potential:</strong> If you traced all tiers, you\'d save '+
        '<span class="hi">'+fH(fs)+'</span> ('+fF(fs/FY)+').';
    } else {
      t.style.display = 'none';
    }

    // Sync active chip to current pos
    document.querySelectorAll('#tsc-chips .tsc-chip').forEach(function(c){
      c.classList.toggle('active', parseInt(c.dataset.v) === pos);
    });
  }

  // ── Event listeners ────────────────────────────────────────
  if (!document.getElementById('tsc-slider')) {
  return;
}
  document.getElementById('tsc-slider').addEventListener('input', function(){
    pos = Math.round(this.value / 50) * 50; // snap to nearest 50
    render();
  });
  document.getElementById('tsc-minus').addEventListener('click', function(){
    pos = Math.max(50, pos - 50);
    render();
  });
  document.getElementById('tsc-plus').addEventListener('click', function(){
    pos = Math.min(20000, pos + 50);
    render();
  });
  document.getElementById('tsc-chips').addEventListener('click', function(e){
    var b = e.target.closest('.tsc-chip');
    if(!b) return;
    pos = parseInt(b.dataset.v);
    render();
  });
  document.getElementById('tsc-depth-opts').addEventListener('click', function(e){
    var b = e.target.closest('.tsc-opt');
    if(!b) return;
    di = parseInt(b.dataset.i);
    document.querySelectorAll('#tsc-depth-opts .tsc-opt').forEach(function(x){
      x.classList.toggle('active', parseInt(x.dataset.i) === di);
    });
    render();
  });
  document.getElementById('tsc-mkt-opts').addEventListener('click', function(e){
    var b = e.target.closest('.tsc-opt');
    if(!b) return;
    mi = parseInt(b.dataset.i);
    document.querySelectorAll('#tsc-mkt-opts .tsc-opt').forEach(function(x){
      x.classList.toggle('active', parseInt(x.dataset.i) === mi);
    });
    render();
  });

  // ── Init ───────────────────────────────────────────────────
  render();

})();



